export default "/images/vendor/flag-icon-css/flags/4x3/il.svg?9bbe130ed5385d0cd03a92060daa40be";